<form class="form" [formGroup]="form">
  <mat-form-field>
    <mat-label>Gender</mat-label>
    <mat-select formControlName="gender">
      <mat-option value="M">M</mat-option>
      <mat-option value="F">F</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Currently uses tobacco?</mat-label>
    <mat-select formControlName="usesTobacco">
      <mat-option [value]="null">Unknown</mat-option>
      <mat-option [value]="true">Yes</mat-option>
      <mat-option [value]="false">No</mat-option>
    </mat-select>
  </mat-form-field>
  @if (form.get('usesTobacco')?.value === false) {
    <mat-form-field>
      <mat-label>Tobacco use history</mat-label>
      <mat-select formControlName="tobaccoNonUseType">
        <mat-option value="NEVER">Never used tobacco</mat-option>
        <mat-option value="FORMER">Former tobacco user</mat-option>
      </mat-select>
    </mat-form-field>
  }
  @if (form.get('usesTobacco')?.value === false && form.get('tobaccoNonUseType')?.value === 'FORMER') {
    <mat-form-field>
      <mat-label>Tobacco Quit Date</mat-label>
      <input matInput [matDatepicker]="picker" [max]="maxDate" formControlName="tobaccoQuitDate">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  }
</form>
<div class="buttons">
  <button mat-raised-button color="primary" class="primarybutton" shape="" [disabled]="!form.valid || !form.dirty" (click)="saveClicked()">Save</button>
  <button mat-raised-button color="primary" class="primarybutton" shape="" [disabled]="!form.dirty" (click)="resetClicked()">Reset</button>
</div>
